var _path;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgVisibilityOffFill1Wght400Grad0Opsz40(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    height: 40,
    width: 40,
    fill: "#3b454e",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "m33.667 37.458-7-6.916q-1.459.541-3.167.833-1.708.292-3.5.292-6.167 0-11.104-3.417-4.938-3.417-7.229-9.083Q2.5 17 3.938 14.979q1.437-2.021 3.437-3.771L2.333 6.167l1.959-1.959 31.25 31.25ZM20 26.375q.542 0 1.125-.083.583-.084 1.042-.25L13.125 17q-.167.5-.25 1.042-.083.541-.083 1.125 0 3.041 2.104 5.125Q17 26.375 20 26.375Zm11.792 1.375-5.375-5.333q.375-.667.583-1.521.208-.854.208-1.729 0-3-2.104-5.104Q23 11.958 20 11.958q-.875 0-1.708.188-.834.187-1.542.604l-4.458-4.5q1.541-.667 3.645-1.125 2.105-.458 4.188-.458 6.083 0 11.021 3.416 4.937 3.417 7.187 9.084-1.041 2.583-2.708 4.771-1.667 2.187-3.833 3.812Zm-7.375-7.375-5.625-5.583q1.208-.375 2.396-.063 1.187.313 2.062 1.146.875.917 1.229 2.021.354 1.104-.062 2.479Z"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgVisibilityOffFill1Wght400Grad0Opsz40);
export default __webpack_public_path__ + "static/media/visibility_off_FILL1_wght400_GRAD0_opsz40.2f482004dbb7ffe2c1a8ed49c7afcb4c.svg";
export { ForwardRef as ReactComponent };